export const ListStatus: string[] = [
  'SELECTED',
  'HOLD',
  'APPLICATION_FORM_RECEIVED',
  'CONTRACT_SENT',
  'SIGNED_CONTRACT_RECEIVED',
  'FIRST_QUARTER_PAYMENT_RECEIVED',
  'FULL_PAYMENT_RECEIVED',
];
